import { Stack } from "@carbon/react";
import { CardComponent, CardRow } from "../../../components/Layouts/Card.styles";
import { HeatMap } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import Card from '../../../components/Layouts/Card';
import { Iframe } from "../../../components/Basics/Iframe.styles";
import InformationContainer from "../../../components/Basics/Information.container";

const SuddenStops = () => {
    return (
        <Stack gap={3}>
            <CardComponent width="100%">
                <Card justifyContent='flex-start' >
                    <HeatMap size={18} />
                    <Typography className='cds--type-heading-compact-01'>
                        MAPA DE DETENCIONES IMPREVISTAS
                    </Typography>
                </Card>
                <InformationContainer description="Las detenciones se actualizan cada 2 minutos" />
                <CardRow width='inherit'>
                    <Card width='100%' padding="0">
                        <Iframe title="Monitoring map" src="https://grafana.terrestra.tech/d/e00e786f-8758-46da-ad69-e290490d7b8f/sudden-stops?orgId=1&refresh=1m&var-intervalo=6h&var-tipo=All&from=1768554579041&to=1768576179041&kiosk" width="100%" height="100%" />
                    </Card>
                </CardRow>
            </CardComponent>
        </Stack>
    )
};

export default SuddenStops;